"use strict";
exports.__esModule = true;
exports.FeatureFlagEnum = void 0;
exports.FeatureFlagEnum = Object.freeze({
    AllowExtensionDowgrade: "allow-extension-upgrade",
    AllowGuideArchive: "allow-guide-archive",
    AttachEmailCalendarFiles: "attach-email-calendar-files",
    CandidateActivity: "candidate-activity",
    CCRecruiter: "cc-recruiter",
    CustomerPlanAndRoles: "customer-plan-and-roles",
    ForceExtensionDowngrade: "force-extension-downgrade",
    InterviewProcessDescriptions: "interview-process-descriptions",
    MultipleICSFiles: "multiple-ics-files",
    PitchPages: "pitch-pages",
    PersistentExtensionButton: "persistent-extension-button",
    ProposeExtensionUpgrade: "propose-extension-upgrade",
    RedesignExtension: "redesign-extension",
    SchedulerPages: "scheduler-pages",
    SendTestEmail: "send-test-email",
    SendViaDjango: "send-via-django",
    UpdaterAgencyList: "updater-agency-list"
});
//# sourceMappingURL=feature-flag-enums.js.map